Notification.requestPermission()

export function NewLeadNotification() {
  new Notification('Tourlane lead qualification', { body: "New Lead was found" });
}

export function displayCallNotification(number, isAutoDialer = false) {
  const body = isAutoDialer ? `Auto Dialer call to ${number}!` : `Inbound Call from ${number}!`;
  const notification = new Notification('Tourlane lead qualification', { body: body });
  notification.onclick = (() => {
    window.focus();
    this.close();
  })
}

export function ReloadToFindLead() {
  // Don't reload if user is in a call
  if (TourlaneFlex.isCalling()) {
    return;
  }
  document.location.href = "/qualification/presales?alarm=true";
}
